var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",class:_vm.rootClass,attrs:{"href":_vm.href,"disabled":!_vm.href && _vm.isDisabled}},_vm.$listeners),[_c('div',{staticClass:"v2-button__layout"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }